import React from 'react';
import PropTypes from 'prop-types';

const Gender = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={24} fill="none" viewBox="0 0 22 24" {...props}>
    <path
      fill={color}
      stroke={color}
      d="M14.12 2.381V1.177l-.853.85L8.94 6.335l-.322.32.288.352a4.703 4.703 0 0 1-.49 6.482 4.75 4.75 0 0 1-6.53-.163 4.705 4.705 0 0 1-.163-6.499 4.752 4.752 0 0 1 6.514-.488l.349.285.319-.318 4.326-4.308.857-.855H8.905a.025.025 0 0 1-.017-.007.02.02 0 0 1-.007-.014.02.02 0 0 1 .007-.015.025.025 0 0 1 .017-.007h5.238c.007 0 .013.003.018.007a.02.02 0 0 1 .006.015v5.217a.02.02 0 0 1-.006.015.025.025 0 0 1-.018.007.025.025 0 0 1-.017-.007l-.353.354.353-.354a.02.02 0 0 1-.007-.015V2.38ZM5.237 5.317a4.699 4.699 0 0 0-3.316 1.368 4.666 4.666 0 0 0 0 6.612 4.699 4.699 0 0 0 6.632 0 4.666 4.666 0 0 0 0-6.612 4.699 4.699 0 0 0-3.316-1.368Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M16.762 8.948a4.2 4.2 0 0 0-2.964 1.222 4.166 4.166 0 0 0 0 5.903 4.2 4.2 0 0 0 5.927 0 4.166 4.166 0 0 0 0-5.903 4.199 4.199 0 0 0-2.963-1.222Zm-5.239 4.174c0-1.01.295-1.998.847-2.844a5.232 5.232 0 0 1 2.267-1.925 5.257 5.257 0 0 1 5.638.9 5.198 5.198 0 0 1 1.462 5.498 5.217 5.217 0 0 1-1.695 2.439 5.25 5.25 0 0 1-2.757 1.123v2.113h2.096a.525.525 0 0 1 .523.522.52.52 0 0 1-.523.522h-2.096v2.608a.52.52 0 0 1-.523.522.525.525 0 0 1-.524-.522V21.47h-2.095a.525.525 0 0 1-.524-.522.52.52 0 0 1 .524-.522h2.095v-2.113a5.246 5.246 0 0 1-3.361-1.691 5.206 5.206 0 0 1-1.354-3.5Z"
      clipRule="evenodd"
    />
  </svg>
);

Gender.propTypes = {
  color: PropTypes.string
};

export default Gender;
